import { get } from "../methods";
function getSecretCode_default() {
  return get({
    url: `api/tools/secret-code`
  });
}
export {
  getSecretCode_default as default
};
